import { IPlatformPageSection, PlatformPageReviewItem } from '@/shared/types/platform-pages';
import ReviewStars from './ReviewStars';
import Image from 'next/image';

interface IProps {
  content: IPlatformPageSection;
}

const Reviews = ({ content }: IProps) => (
  <ul className="section-inner reviews">
    {(content.reviewItems || []).map((reviewItem: PlatformPageReviewItem) => {
      return (
        <li key={reviewItem.text} className="review-item">
          <p className="review-item-content">{reviewItem.text}</p>
          <div className="review-item-star">{ReviewStars(reviewItem.stars)}</div>
          <div className="review-item-author">
            <Image
              className="review-item-author-avator"
              src={reviewItem.avatar}
              width={56}
              height={56}
              alt={reviewItem.name}
            />
            <p className="review-item-author-text">
              <span className="review-item-author-name">{reviewItem.name}</span>
              <br />
              <span className="review-item-author-org">{reviewItem.org}</span>
            </p>
          </div>
        </li>
      );
    })}
  </ul>
);

export default Reviews;
